import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Message } from 'primeng/message';
import { AsyncPipe } from '@angular/common';
import { SafeHtmlPipe } from '../../pipes/safe-html-pipe';
import { TextResourcePipe } from '../../pipes/text-resource.pipe';

@Component({
  selector: 'app-info-message',
  imports: [Message, AsyncPipe, SafeHtmlPipe, TextResourcePipe],
  templateUrl: './info-message.component.html',
  styleUrl: './info-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoMessageComponent {
  public label = input<string>();
  public labelHTML = input<string>();
}
